export const laspenas = {
	nombre: "Las Penas",
	dia: "Domingo de Ramos",
	nombrecompleto:
		"Venerable y Real Archicofradía de Nuestra Señora del Pilar de Zaragoza, Nuestro Padre Jesús de las Penas y María Santísima de la Caridad",
	sede: "Parroquia de San Lorenzo Diácono y Mártir",
	pasos: 2,
	distancia: [1070, 1080],
	penitentes: 140,
	cargadores: 114,
	web: "http://www.diariodecadiz.es/semana_santa/Penas_0_1229277786.html",
	ida: [
		{ lng: -6.3004124, lat: 36.5315811 },
		{ lng: -6.3003588, lat: 36.5315451 },
		{ lng: -6.3001415, lat: 36.5318619 },
		{ lng: -6.2995327, lat: 36.5315882 },
		{ lng: -6.2982881, lat: 36.531114 },
		{ lng: -6.2975961, lat: 36.5309265 },
		{ lng: -6.2975639, lat: 36.5310041 },
		{ lng: -6.2970597, lat: 36.530864 },
		{ lng: -6.2967512, lat: 36.530836 },
		{ lng: -6.2962925, lat: 36.5305795 },
		{ lng: -6.2955281, lat: 36.529851 },
		{ lng: -6.2953243, lat: 36.5296948 },
		{ lng: -6.2950333, lat: 36.5296145 },
		{ lng: -6.2948797, lat: 36.5296175 },
		{ lng: -6.2945963, lat: 36.5295609 },
		{ lng: -6.2943388, lat: 36.5305448 },
		{ lng: -6.2939284, lat: 36.5306146 },
		{ lng: -6.2935127, lat: 36.5307274 },
		{ lng: -6.2929273, lat: 36.5310815 },
		{ lng: -6.2922021, lat: 36.5302846 },
		{ lng: -6.2928909, lat: 36.5297794 },
		{ lng: -6.2937168, lat: 36.5297036 },
		{ lng: -6.2945397, lat: 36.5296318 },
		{ lng: -6.294572, lat: 36.5295274 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.295681, lat: 36.529157 },
		{ lng: -6.2955013, lat: 36.5295881 },
		{ lng: -6.2953886, lat: 36.529726 },
		{ lng: -6.2955442, lat: 36.5298381 },
		{ lng: -6.2960806, lat: 36.5303316 },
		{ lng: -6.2958224, lat: 36.5306565 },
		{ lng: -6.295626, lat: 36.5309944 },
		{ lng: -6.2950158, lat: 36.5308403 },
		{ lng: -6.2949353, lat: 36.5308403 },
		{ lng: -6.2949461, lat: 36.5314632 },
		{ lng: -6.2963972, lat: 36.5317628 },
		{ lng: -6.2966761, lat: 36.5323285 },
		{ lng: -6.2969765, lat: 36.532808 },
		{ lng: -6.2973828, lat: 36.5325548 },
		{ lng: -6.2979715, lat: 36.5327833 },
		{ lng: -6.2984926, lat: 36.5319621 },
		{ lng: -6.2995135, lat: 36.5323274 },
		{ lng: -6.300154, lat: 36.5318775 },
		{ lng: -6.3003616, lat: 36.5315707 },
		{ lng: -6.3003949, lat: 36.5315903 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-25T15:15",
			latlng: [36.5316, -6.3004]
		},
		{
			name: "Nueva",
			hora: "2018-03-25T17:45",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-25T18:45",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-25T19:45",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-25T20:10",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-25T20:20",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Sagasta (derecha)",
			"Hospital de Mujeres",
			"Plaza Libertad",
			"Plaza Topete",
			"Compañía",
			"Plaza Pío XII",
			"Cobos",
			"Cristóbal Colón",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C"
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañia",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		[
			"San Miguel",
			"Gaspar del Pino",
			"Benjumeda",
			"Marqués del Real Tesoro",
			"Sacramento",
			"Sagasta (izquierda)",
			"a su Templo"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/laspenas.js